export const getAuthToken = () => {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user') as string);
  if (user && user.token) {
    // console.warn('***** user.token exists');
    return user.token;
  } else {
    console.error('***** user.token is missing from localStorage');
  }
};

export const authHeader = () => {
  const token = getAuthToken();
  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
};
